"use strict";
module.exports = function (app) {
    app.directive('vmAudio', function (ngAudio){
        return {
            scope: {
                'lastBid': '='
            },
            restrict: "A",
            link: function (scope, iElement, iAttrs) {
                var audioUrl = require('../assets/sound/bell_ding.wav');
                scope.audio = ngAudio.load(audioUrl);
                //this always run firstly before the resize event
                scope.$watch('lastBid', function (newVal, oldVal) {
                    if (oldVal && newVal && newVal.products_id === oldVal.products_id) {
                        //checking if 2 bids are different to avoid concurrent problems from server sending multiple times same object
                        if (oldVal && newVal && oldVal.bids_id !== newVal.bids_id && !newVal.auto) {
                            scope.audio.play();
                        }
                        else if (oldVal === undefined && newVal !== undefined && !newVal.auto) {
                            //if this is the first bid compared with already existing $scope.displayProduct before assign it again
                            scope.audio.play();
                        }
                    }
                });

                scope.$on('$destroy', function() {
                    scope.audio.unbind();
                });

            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/js/bid_audio.directive.js
 ** module id = 43
 ** module chunks = 0
 **/